import { systemIntents } from '../utils/flowNode';
import { addNodeId } from '../utils/nodeIdPool';

const store = {
  namespaced: true,
  state: {
    intents: [],
  },
  getters: {
    intentsMap: state => {
      return [...state.intents, ...systemIntents].reduce((map, next) => {
        map[next.id] = next;
        return map;
      }, {})
    },
  },
  mutations: {
    SET_INTENTS(state, intents) {
      state.intents = intents;
    },
    ADD_INTENT(state, intent) {
      state.intents.push(intent);
    },
    UPDATE_INTENT(state, intent) {
      const index = state.intents.findIndex(item => item.id === intent.id);
      if (index === -1) return
      state.intents.splice(index, 1, intent);
    },
    DEL_INTENT(state, intentId) {
      const index = state.intents.findIndex(item => item.id === intentId);
      if (index === -1) return
      state.intents.splice(index, 1);
    },
  },
  actions: {
    setIntents({ commit }, intents) {
      commit('SET_INTENTS', intents)
    },
    saveIntent({ commit, state, dispatch }, intent) {
      if (intent.id) {
        commit('UPDATE_INTENT', intent)
      } else {
        intent.id = addNodeId('I');
        commit('ADD_INTENT', intent)
      }
      return dispatch('scene/savePortionScene', { key: 'intents', data: state.intents }, { root: true })
    },
    delIntent({ commit, dispatch, state }, intentId) {
      commit('DEL_INTENT', intentId);
      return dispatch('scene/savePortionScene', { key: 'intents', data: state.intents }, { root: true })
    },
  },
}
export default store
